// PublicRoute.js
import { useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

export default function PublicRoute({ children }) {
    const { isLoggedIn } = useAuth();
    const navigate = useNavigate();


    // If the user is not authenticated, render the children components
    return children;
};